// Remove Main ID card

attachEvent('.loyalty-preview__card-remove', 'click', async (ev) => {
  ev.preventDefault();

  // eslint-disable-next-line no-alert
  const confirmed = confirm(localData.translations.loyalty_card_remove_confirm);
  if (!confirmed) {
    return;
  }

  try {
    const { data } = await axios.post(localData.apiURL, {
      action: 'removeLoyaltyCard',
    });
    if (data.success) {
      window.location.reload();
    } else {
      // eslint-disable-next-line no-alert
      alert(data.data?.msg || 'Unable to remove card. Please try again.');
    }
  } catch (error) {
    // eslint-disable-next-line no-alert
    alert('Unable to remove card. Please try again.');
    console.error(error);
  }
});
